/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartQuantitySelect_item$ref: FragmentReference;
export type CartQuantitySelect_item = {|
  +quantity: ?number,
  +hasUnlimitedQuantity: ?boolean,
  +setSize: ?number,
  +quantitySelectOptions: ?$ReadOnlyArray<?{|
    +label: ?string,
    +value: ?number,
  |}>,
  +$refType: CartQuantitySelect_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartQuantitySelect_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "quantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasUnlimitedQuantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "setSize",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quantitySelectOptions",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemQuantityOption",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "label",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '475302b2cb0f6cbeb7aaf772928cc3ac';
module.exports = node;
